<form [formGroup]="form">
  <app-input-group>
    <label appLabel for="wholesale-export-start-date">{{ 'common.date.start' | translate }}</label>
    <input id="wholesale-export-start-date" type="date" appInput formControlName="startDate">
  </app-input-group>

  <app-input-group>
    <label appLabel for="wholesale-export-end-date">{{ 'common.date.end' | translate }}</label>
    <input id="wholesale-export-end-date" type="date" appInput formControlName="endDate">
  </app-input-group>

  <div class="mt-6 space-y-4">
    <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
      <div class="flex items-center justify-between gap-4">
        <span class="text-sm font-medium">{{ engrosfiksering.label }}</span>
      </div>
      @if (getCorrectionDateRange(engrosfiksering.monthsOffset)) {
        <span class="text-xs text-gray-500 mt-1 block">{{ getCorrectionDateRange(engrosfiksering.monthsOffset)!.start }} → {{ getCorrectionDateRange(engrosfiksering.monthsOffset)!.end }}</span>
      }
    </div>

    <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'settlement.wholesale.exportReport.selectTypes' | translate }}</h3>

    <div class="flex items-center justify-between gap-4 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-3">
        <app-toggle formControlName="korrektion1"></app-toggle>
        <span class="text-sm font-medium">{{ korrektioner[0].label }}</span>
      </div>
      @if (getCorrectionDateRange(korrektioner[0].monthsOffset)) {
        <span class="text-xs text-gray-500">{{ getCorrectionDateRange(korrektioner[0].monthsOffset)!.start }} → {{ getCorrectionDateRange(korrektioner[0].monthsOffset)!.end }}</span>
      }
    </div>

    <div class="flex items-center justify-between gap-4 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-3">
        <app-toggle formControlName="korrektion2"></app-toggle>
        <span class="text-sm font-medium">{{ korrektioner[1].label }}</span>
      </div>
      @if (getCorrectionDateRange(korrektioner[1].monthsOffset)) {
        <span class="text-xs text-gray-500">{{ getCorrectionDateRange(korrektioner[1].monthsOffset)!.start }} → {{ getCorrectionDateRange(korrektioner[1].monthsOffset)!.end }}</span>
      }
    </div>

    <div class="flex items-center justify-between gap-4 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-3">
        <app-toggle formControlName="korrektion3"></app-toggle>
        <span class="text-sm font-medium">{{ korrektioner[2].label }}</span>
      </div>
      @if (getCorrectionDateRange(korrektioner[2].monthsOffset)) {
        <span class="text-xs text-gray-500">{{ getCorrectionDateRange(korrektioner[2].monthsOffset)!.start }} → {{ getCorrectionDateRange(korrektioner[2].monthsOffset)!.end }}</span>
      }
    </div>
  </div>
</form>
